"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xlarge = exports.small = exports.medium = exports.media = exports.large = exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _polished = require("polished");

var _styledComponents = require("styled-components");

var emMaxWidthBuffer = function emMaxWidthBuffer(maxWidth) {
  var buffer = (0, _polished.em)('1px');
  var bufferValue = buffer.substring(0, buffer.length - 2);
  var maxWidthValue = maxWidth.substring(0, maxWidth.length - 2);
  return "".concat(maxWidthValue - bufferValue, "em");
};

var small = (0, _polished.em)('0px');
exports.small = small;
var medium = (0, _polished.em)('768px');
exports.medium = medium;
var large = (0, _polished.em)('1024px');
exports.large = large;
var xlarge = (0, _polished.em)('1200px'); // TODO: add portrait and landscape

exports.xlarge = xlarge;
var breakpoints = {
  small: small,
  medium: medium,
  large: large,
  xlarge: xlarge
}; // Iterate through the labels and create a media template

var labels = {
  small: small,
  medium: medium,
  large: large,
  xlarge: xlarge,
  smallMedium: [small, medium],
  smallLarge: [small, large],
  smallXlarge: [small, xlarge],
  mediumLarge: [medium, large],
  mediumXlarge: [medium, xlarge],
  largeXlarge: [large, xlarge]
};

var cssBuilder = function cssBuilder(strings) {
  if (arguments.length <= 1 ? 0 : arguments.length - 1) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#Tagged_templates
    // https://www.styled-components.com/docs/api#css
    throw Error('media.$breakpoint called without css() use media.$breakpoint(css`/* styles */`)\n ex. media.smallMedium(css`/* styles */`)');
  } else {
    return strings;
  }
};

var media = Object.keys(labels).reduce(function (acc, label) {
  var breakpoint = labels[label];

  if (Array.isArray(breakpoint)) {
    var _breakpoint = (0, _slicedToArray2.default)(breakpoint, 2),
        start = _breakpoint[0],
        end = _breakpoint[1];

    acc[label] = function (cssStrings) {
      for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        keys[_key - 1] = arguments[_key];
      }

      return (0, _styledComponents.css)(["@media (min-width:", ") and (max-width:", "){", ";}"], start, emMaxWidthBuffer(end), cssBuilder.apply(void 0, [cssStrings].concat(keys)));
    };
  } else {
    acc[label] = function (cssStrings) {
      for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        keys[_key2 - 1] = arguments[_key2];
      }

      return (0, _styledComponents.css)(["@media (min-width:", "){", ";}"], breakpoints[label], cssBuilder.apply(void 0, [cssStrings].concat(keys)));
    };
  }

  return acc;
}, {});
exports.media = media;
var _default = media;
exports.default = _default;
//# sourceMappingURL=media.js.map